const state = {
  QAmodal: false,
  aboutModal: false,
  settingModal: false
};
const mutations = {
  modalOpen(state, target){
    state[target] = true;
  },
  modalClose(state, target){
    state[target] = false;
  }
};
export default{
  namespaced: true,
  state,
  mutations
}